function n(n,f,i,o){n._m(f),n.o(f,"MainButton",()=>n.f(t));var t=n.i(i("7f416d53"));}